// export const DIALOG_WIDTH = 870;
export const DIALOG_MAX_WIDTH = 'calc(100vw - 128px)';
export const MUI_DIALOG_MAX_HEIGHT = 'calc(100vh - 128px)';
export const MUI_DIALOG_MAX_HEIGHT_MINUS = (pixels) => `calc(100vh - ${pixels + 128}px)`;

export const TITLE_HEIGHT = 45;
export const TAB_CONTENT_HEIGHT = 500;
export const BUTTONS_SECTION_HEIGHT = 75;
export const CONTENT_HEIGHT = MUI_DIALOG_MAX_HEIGHT_MINUS(BUTTONS_SECTION_HEIGHT + TITLE_HEIGHT);
export const PREVIEW_AND_PROPS_PADDING = 20;
export const PREVIEW_AND_PROPS_HEIGHT = MUI_DIALOG_MAX_HEIGHT_MINUS(BUTTONS_SECTION_HEIGHT + TITLE_HEIGHT + PREVIEW_AND_PROPS_PADDING * 2);
export const TAB_CONTENT_MAX_HEIGHT = MUI_DIALOG_MAX_HEIGHT_MINUS(BUTTONS_SECTION_HEIGHT + TITLE_HEIGHT);
